import React from "react";
import classNames from "classnames";
import styles from "./index.module.scss";
import { Icon } from "@/elements-react/fix-icon";

export interface CartProductNotifyTitleProps {
  text: string;
  colorType?: "error" | "warning" | "info" | "success";
  className?: string;
}

const iconMap = {
  error: "exclamation-octagon",
  warning: "exclamation-triangle",
  info: "info-circle",
  success: "check-circle",
};

const CartProductNotifyTitle: React.FC<CartProductNotifyTitleProps> = ({ text, colorType = "error", className }) => {
  const iconName = iconMap[colorType] || iconMap.error;

  return (
    <div className={classNames(styles.root, styles[colorType], className)}>
      <span className={styles.icon}>
        <Icon name={iconName} />
      </span>
      <span className={styles.text}>{text}</span>
    </div>
  );
};

export default CartProductNotifyTitle;
